module.exports = new __parcel__URL__("objective_view_button.c68f3fed.png").toString();